import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * LogChannelChip - Indicador de canal de uma linha de log (Admin Geral > Logs)
 *
 * O canal é livre (qualquer string vira arquivo via app_log_channel()), então usa
 * uma única cor neutra para todos os canais — a mesma azul já usada em FeedbackBadges
 * (tipo "Melhoria"), sem inventar paleta nova.
 *
 * @param {Object} props
 * @param {string} props.channel
 */
function LogChannelChip({ channel }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: '#E3F2FD',
        border: '1px solid #BBDEFB',
        width: 'fit-content',
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: '#1565C0', whiteSpace: 'nowrap' }}
      >
        {channel || '—'}
      </Typography>
    </Box>
  );
}

export default LogChannelChip;
